<tr [formGroup]="taskForm" (appClickOutside)="clickedOutside()" (ngSubmit)="save()"
    [ngClass]="{'shift-split': employeeTask.isShiftSplitTask}">
    <td class="flex-3" appTitleProvider>
        <span>{{ employeeTask.serviceName }}</span>
    </td>
    @if (rosterPresent) {
        <td class="flex-2" appTitleProvider>
            <span>{{ employeeTask.rosterDepartmentName }}</span>
        </td>
    }
    <td class="flex-2" appTitleProvider>
        <span>{{ employeeTask | fromto }}</span>
    </td>
    <td class="flex-1 justify-content-center" appTitleProvider>
        @if (employeeTask.isShiftSplitTask !== true && !employeeTask.isSyncedInitially) {
            <app-form-input
                type="number"
                formControlName="duration"
                [error]="getTaskDurationError(taskForm)"
                [disable]="saving"
            ></app-form-input>
        }
        @if (employeeTask.isShiftSplitTask || employeeTask.isSyncedInitially) {
            <span>{{ employeeTask.duration }}</span>
        }
    </td>
    <td class="flex-2 justify-content-center">
        <app-checkbox
            class="pl-2"
            formControlName="active"
            [id]="employeeTask.taskId + '-assigned'"
            [value]="employeeTask.isActive"
            [disable]="employeeTask.disabled"
        ></app-checkbox>
        @if (employeeTask.disabled) {
            <app-info-tooltip
                appCustomPopover
                iconSize="sm"
                class="ml-2"
                placement="top"
                popoverText="{{employeeTask.isShiftSplitTask? 'TIME_WINDOW_OVERLAP' : 'SPLIT_SHIFT_DISABLED_TASK_OVERLAP' }}">
            </app-info-tooltip>
        }
    </td>
    <td class="flex-1 justify-content-center">
        @if (!saving) {
            <app-tooltip title="{{'REVERT' | translate}}" [compact]="true"
                         class="mr-2">
                <ng-container icon>
                    <button
                        type="reset"
                        (click)="revert()"
                        class="vismaicon vismaicon-sm vismaicon-refresh vismaicon-reverse vismaicon-button"
                        [ngClass]="{ disabled: taskForm.pristine }"
                    ></button>
                </ng-container>
            </app-tooltip>
            <app-tooltip title="{{'SAVE' | translate}}" [compact]="true">
                <ng-container icon>
                    <button
                        type="submit"
                        (click)="save($event)"
                        class="vismaicon vismaicon-sm vismaicon-save vismaicon-button"
                        [ngClass]="{ disabled: taskForm.pristine || taskForm.invalid }"
                    ></button>
                </ng-container>
            </app-tooltip>
        }
        @if (saving) {
            <div class="spinner"></div>
        }
    </td>
    @if (taskAddressPresent) {
        <td class="flex-1"></td>
    }
    <td class="icon-column"></td>
</tr>
